import { useState } from "react";
import { login } from "../services/api";
import { saveSession } from "../auth";
import Button from "../components/Button";
import { Input } from "../components/Input";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

export default function Login() {
  const nav = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const session = await login({ email, password });
      saveSession(session);
      nav("/dashboard");
    } catch (err) {
      setError(err?.message || t("login.error_generic"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white shadow-lg p-8 text-center">
        {/* Logo at the top */}
        <img
          src="/favicon.png"
          alt="Zero Riscuri Logo"
          className="mx-auto h-56 w-56 sm:h-64 sm:w-64 object-contain"
        />

        <h1 className="text-2xl font-bold text-slate-900 mb-1">{t("login.title")}</h1>
        <p className="text-sm text-slate-500 mb-6">{t("login.subtitle")}</p>

        <form onSubmit={onSubmit} className="space-y-4 text-left">
          <div>
            <label className="block text-xs text-slate-500 font-medium mb-1">
              {t("login.email_label")}
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("login.email_placeholder")}
            />
          </div>
          <div>
            <label className="block text-xs text-slate-500 font-medium mb-1">
              {t("login.password_label")}
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t("login.password_placeholder")}
            />
          </div>
          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-3 py-2">{error}</div>}
          <Button disabled={loading} className="w-full justify-center">
            {loading ? t("login.button_loading") : t("login.button_continue")}
          </Button>
          <div className="text-center pt-1">
            <Link to="/forgot-password" className="text-sm text-blue-600 hover:text-blue-800 underline">
              {t("login.forgot_password")}
            </Link>
          </div>
        </form>

        <div className="mt-5 text-xs text-slate-500">
          <Trans i18nKey="login.tip">
            Tip: Use <code>admin@acme.com</code> to simulate an Org Super Admin.
          </Trans>
        </div>
        <div className="mt-2 text-xs text-slate-500">
          <span>{t('login.create_account_prefix')} </span>
          <a
            href="https://workforcemanagement.certasign.hypen.ro/register"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            {t('login.create_account_link')}
          </a>
        </div>
      </div>
    </div>
  );
}
